import React from "react";
import { Grid, Stack, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
//Srcs
import "./setting.scss";
import ExpenseType from "../Assets/finance.png";
// import User from "../Assets/customer.png";
// import Supplier from "../Assets/supplier.png";

export default function Report() {
  return (
    <div className="setting-page">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">Report</Typography>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              Dashboard
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">Report</Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ mt: "30px" }}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link
              to="/report/income-report"
              style={{ textDecoration: "none" }}
            >
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={ExpenseType} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      Income
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link
              to="/report/student-statistic-by-academic-year"
              style={{ textDecoration: "none" }}
            >
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={ExpenseType} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      Student Statistics By Class
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link
              to="/report/student-payment-report"
              style={{ textDecoration: "none" }}
            >
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={ExpenseType} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      Student need to pay
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link
              to="/report/disbursement-report"
              style={{ textDecoration: "none" }}
            >
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={ExpenseType} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      Disbursement
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>

        </Grid>
      </Box>
    </div>
  );
}
